if (!customElements.get('metal-stake-personalization')) {
  customElements.define('metal-stake-personalization', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.form = this.closest('form');
      this.input = this.querySelector('[data-metal-photo]');
      this.canvas = this.querySelector('canvas');
      this.confirm = this.querySelector('[data-metal-confirm]');
      this.error = this.querySelector('[data-metal-error]');
      this.status = this.querySelector('[data-metal-status]');
      this.fields = [...this.querySelectorAll('[data-metal-text]')];
      this.form.addEventListener('input', event => {
        this.revision = (this.revision || 0) + 1;
        if (event.target !== this.confirm) this.confirm.checked = false;
        this.validateText(); this.draw();
      }, options);
      this.form.addEventListener('change', event => {
        this.revision = (this.revision || 0) + 1;
        if (event.target !== this.confirm) this.confirm.checked = false;
        if (event.target === this.input) this.loadPhoto();
      }, options);
      this.querySelector('[data-metal-remove]').addEventListener('click', () => { this.input.value = ''; this.loadPhoto(); }, options);
      this.form.addEventListener('submit', event => this.add(event), {...options, capture: true});
      this.validateText(); this.dataset.ready = 'true';
    }

    validateText() {
      for (const field of this.fields) field.setCustomValidity(!field.value.trim() || field.value.length > field.maxLength ? this.dataset.textError : '');
      const message = this.querySelector('[data-metal-text="message"]');
      this.querySelector('[data-metal-count]').textContent = `${message.value.length} / 35`;
    }

    async loadPhoto() {
      const version = this.version = (this.version || 0) + 1;
      if (this.photoUrl) URL.revokeObjectURL(this.photoUrl);
      this.photoUrl = null; this.photo = null; this.confirm.checked = false;
      this.input.setCustomValidity(''); this.status.textContent = ''; this.error.hidden = true;
      this.querySelector('[data-metal-review]').hidden = true;
      const file = this.input.files[0];
      this.querySelector('[data-metal-remove]').hidden = !file;
      if (!file) return;
      if (!['image/jpeg','image/png','image/webp'].includes(file.type) || file.size > 10 * 1024 * 1024) { this.invalidPhoto(); return; }
      const url = this.photoUrl = URL.createObjectURL(file);
      this.input.setCustomValidity(this.dataset.loading); this.status.textContent = this.dataset.loading;
      try {
        const photo = new Image(); photo.src = url; await photo.decode();
        if (version !== this.version || !this.isConnected) return;
        if (!photo.naturalWidth || photo.naturalWidth * photo.naturalHeight > 80000000) throw new Error('Invalid photo');
        this.photo = photo; this.input.setCustomValidity(''); this.status.textContent = file.name;
        this.querySelector('[data-metal-review]').hidden = false; this.draw();
      } catch { if (version === this.version) this.invalidPhoto(); }
    }

    invalidPhoto() {
      if (this.photoUrl) URL.revokeObjectURL(this.photoUrl);
      this.photoUrl = null; this.photo = null; this.input.value = '';
      this.input.setCustomValidity(this.dataset.photoError); this.status.textContent = '';
      this.showError(this.dataset.photoError);
    }

    draw() {
      if (!this.photo) return;
      const ctx = this.canvas.getContext('2d');
      ctx.clearRect(0, 0, 720, 840); ctx.fillStyle = '#f2f0e9'; ctx.fillRect(0,0,720,840);
      ctx.fillStyle = '#222622'; ctx.fillRect(70,165,580,320);
      ctx.beginPath(); ctx.ellipse(360,165,166,100,0,Math.PI,0); ctx.fill();
      ctx.fillRect(326,480,68,248); ctx.beginPath(); ctx.moveTo(326,728); ctx.lineTo(360,780); ctx.lineTo(394,728); ctx.fill();
      ctx.fillStyle = '#faf6ed'; ctx.textAlign = 'center'; ctx.font = '21px Georgia, serif'; ctx.fillText('In Loving Memory of',360,119);
      for (const [x,y,r] of [[360,150,6],[350,140,3],[358,135,3],[366,136,3],[373,142,3]]) { ctx.beginPath(); ctx.arc(x,y,r,0,Math.PI*2); ctx.fill(); }
      const photoBox = [390,205,224,239];
      ctx.fillStyle = '#e9e8df'; ctx.fillRect(...photoBox);
      const scale = Math.min(photoBox[2]/this.photo.naturalWidth,photoBox[3]/this.photo.naturalHeight);
      ctx.drawImage(this.photo,photoBox[0]+(photoBox[2]-this.photo.naturalWidth*scale)/2,photoBox[1]+(photoBox[3]-this.photo.naturalHeight*scale)/2,this.photo.naturalWidth*scale,this.photo.naturalHeight*scale);
      ctx.fillStyle = '#faf6ed';
      const value = key => this.querySelector(`[data-metal-text="${key}"]`).value.trim();
      const fit = (text,y,size,font) => {
        ctx.font = `${size}px ${font}`;
        while (ctx.measureText(text).width>260 && size>12) ctx.font = `${--size}px ${font}`;
        ctx.fillText(text,226,y,260);
      };
      fit(value('name'),252,36,'Georgia, serif'); fit(value('dates'),300,17,'Arial, sans-serif');
      const words = value('message').split(/\s+/), lines = []; let line = '';
      ctx.font = '19px Arial, sans-serif';
      for (const word of words) {
        const next = line ? line+' '+word : word;
        if (ctx.measureText(next).width>250 && line) { lines.push(line); line=word; } else line=next;
      }
      if (line) lines.push(line);
      lines.slice(0,3).forEach((text,i)=>fit(text,349+i*28,19,'Arial, sans-serif'));
    }

    showError(message) { this.error.textContent = message; this.error.hidden = false; }

    async add(event) {
      event.preventDefault(); event.stopImmediatePropagation();
      const submit = this.form.querySelector('[data-product-submit]');
      this.validateText();
      if (this.busy || submit.disabled || !this.form.reportValidity() || !this.photo) return;
      const version = this.version, revision = this.revision;
      const data = new FormData(this.form);
      this.fields.forEach(field => data.set(field.name,field.value.trim()));
      this.busy = true; submit.disabled = true; this.error.hidden = true;
      const label = submit.querySelector('[data-submit-label]'), previous = label.textContent;
      label.textContent = submit.dataset.addingLabel;
      try {
        this.draw();
        const blob = await new Promise(resolve=>this.canvas.toBlob(resolve,'image/png'));
        if (!blob || version!==this.version || revision!==this.revision || !this.confirm.checked) throw new Error('Details changed');
        data.set('properties[Layout preview]',blob,'memorial-stake-preview.png');
        const response = await fetch(new URL(this.form.action,location.origin).pathname.replace(/\/$/,'')+'.js',{method:'POST',headers:{Accept:'application/json'},body:data});
        if (!response.ok) throw new Error('Add failed');
        await response.json();
        document.dispatchEvent(new CustomEvent('echoes:cart-refresh',{detail:{open:true}}));
      } catch { this.showError(this.dataset.addError); }
      finally { this.busy=false; submit.disabled=false; label.textContent=previous; }
    }

    disconnectedCallback() { this.controller?.abort(); this.controller=null; this.version=(this.version||0)+1; if (this.photoUrl) URL.revokeObjectURL(this.photoUrl); }
  });
}
